export default "__VITE_ASSET__CZQmEFz3__"